import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks/translation/TranslationContext";
import CustomerButton from "../../customer-button/CustomerButton";
import { wrapTextForRTL } from "./TestimonialScreen";
const useStyles = makeStyles({
  container: {
    padding: 16,
    textAlign: "center"
  },
  closeButton: {
    width: 100,
    marginTop: 24
  }
});
const ThankYouScreen = ({
  onCancelDialog
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    className: classes.container
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, wrapTextForRTL(t("Thank you!")))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, t("Your feedback matters to us"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    style: {
      width: 100,
      marginTop: 24
    },
    onClick: onCancelDialog,
    id: "closeButton",
    component: "div"
  }, "Close")));
};
ThankYouScreen.propTypes = {
  onCancelDialog: PropTypes.func.isRequired
};
export default ThankYouScreen;